function handlePrice() {
  const lineItem = document.querySelectorAll(".mu-cart-item");
  lineItem.forEach((item) => {
    const title = item.querySelector(".mu-item-title").innerText;
    const variant = item.querySelector(".mu-item-variants").innerText;
    let cartKey = "";
    BSS_B2B.shopData.cart.items.forEach((i) => {
      if (title === i.product_title) {
        cartKey = i.key;
      }
    });
    const price = item.querySelector(".mu-item-price");
    price.setAttribute("bss-b2b-cart-item-key", cartKey);
    price.setAttribute("bss-b2b-item-original-price", "");
  });
  document
    .querySelector(".mu-subtotal [data-value]")
    .setAttribute("bss-b2b-cart-total-price", "true");
  BSS_B2B.observer.cartSubject.notifyObserver("CartUpdate", "CartMutate");
}

function handle() {
  const target = document.querySelector("#mu-checkout-button");
  if (target) {
    const prev = target.previousElementSibling;

    const isAlreadyInserted =
      prev &&
      prev.tagName.toLowerCase() === "button" &&
      prev.classList.contains("bss-custom");

    if (!isAlreadyInserted) {
      target.insertAdjacentHTML(
        "beforebegin",
        `
        <button class="bss-custom mu-custom-btn mu-w-full mu-py-3 mu-mb-2 mu-checkout-btn mu-flex mu-items-center mu-justify-center mu-rounded" style="
          background-color: rgb(42, 71, 60);
          border: inherit;
          text-decoration: none;
          font-family: inherit;
          font-size: 1.3em;
          color: rgb(255, 255, 255);
          --hover-background: rgba(215, 222, 255, 1);
        ">
          Fortsätt till kassan
        </button>
      `
      );
      target.style.display = "none";
    }
    BSS_B2B.observer.cartSubject.listenCartCheckout();
  }
}

function addCustomCheckoutClickHandler() {
  const button = document.querySelector(".bss-custom");
  if (button) {
    button.addEventListener(
      "click",
      () => {
        button.style.display = "none";
        setTimeout(() => {
          button.style.display = "";
        }, 2200);
      },
      true
    );
  }
}

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      for (let item of MutationList) {
        if (
          item.target.classList.contains("mu-item-price") ||
          item.target.id === "mu-checkout-container"
        ) {
          handlePrice();
          handle();
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);
  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(addCustomCheckoutClickHandler, 2000);
  });
}
